import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Suspense as _Suspense, isRef as _isRef, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "copyright" }
const _hoisted_2 = { class: "message-wrapper row text-center" }

import {
  computed,
  onBeforeMount,
  onMounted,
  ref,
} from 'vue';

import ModalContainer from '~components/modals/ModalContainer.vue';
import { useMainStore } from '@/store';
import { useAuthStore } from '@/store/auth/authModule';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import AppLoader from '~components/AppLoader.vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { height, tabsHeaderHeight } from './constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "v3f05f823": (wrapperStyleHeight),
  "dac2557e": (tabsWrapperStyleHeight)
}))

const isMobileOnly = () => {
  const { userAgent, maxTouchPoints } = navigator;
  const width = Math.min(window.screen.width, window.screen.height);

  if (
    /(ipad|tablet|playbook|silk)|(android(?!.*mobile))|(windows|linux|macintosh)/i.test(userAgent)
    || (maxTouchPoints > 1 && width >= 768)
  ) return false;

  return (
    /mobi|phone|iphone|ipod|android.*mobile|blackberry|opera mini|iemobile/i.test(userAgent)
    || width < 768
  );
};

const authStore = useAuthStore();
const router = useRouter();

const isLoading = ref(false);
const isLandscape = ref(false);

const { isAuth, isEmbedded } = storeToRefs(authStore);

const authInProcess = ref(false);

onBeforeMount(async () => {
  isLoading.value = true;
  // Ждем гард: для /catch он уже выставит авторизацию от родителя,
  // и autenticate по кукам не перетрет constantParams
  await router.isReady();
  await authStore.autenticate();
  isLoading.value = false;
});

onMounted(() => {
  if (isMobileOnly()) {
    // eslint-disable-next-line no-restricted-globals
    const { orientation } = screen;
    if (orientation.angle !== 0) {
      isLandscape.value = true;
    }
    orientation.addEventListener('change', (evt: Event) => {
      console.log(orientation.angle);
      if (orientation.angle === 90 || orientation.angle === 270) isLandscape.value = true;
      else isLandscape.value = false;
    });
  }
});

const {
  modal,
  maximized,
  message,
  messageContent,
  reportMode,
} = storeToRefs(useMainStore());

const messageShown = computed(() => Boolean(message.value));

const closeModal = () => {
  useMainStore().closeModal();
};

const wrapperStyleHeight = `calc(100vh - ${height}px)`;
const tabsWrapperStyleHeight = `calc(100vh - ${height + tabsHeaderHeight}px)`;

return (_ctx: any,_cache: any) => {
  const _component_LandscapeLayout = _resolveComponent("LandscapeLayout")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, null, {
    default: _withCtx(() => [
      (isLandscape.value)
        ? (_openBlock(), _createBlock(_component_LandscapeLayout, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(isAuth) && !_unref(isEmbedded) && !authInProcess.value)
        ? (_openBlock(), _createBlock(BaseLayout, {
            key: 1,
            isLoading: isLoading.value
          }, null, 8, ["isLoading"]))
        : (_openBlock(), _createBlock(_component_router_view, { key: 2 })),
      (isLoading.value)
        ? (_openBlock(), _createBlock(_component_q_inner_loading, {
            key: 3,
            showing: isLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(AppLoader)
            ]),
            _: 1
          }, 8, ["showing"]))
        : _createCommentVNode("", true),
      (!_unref(isAuth) && !_unref(isEmbedded))
        ? (_openBlock(), _createBlock(_component_q_footer, {
            key: 4,
            class: "bg-grey-3 text-primary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar, { class: "base-footer" }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-primary" }, "Место для вашего заголовка", -1)),
                  _createVNode(_component_q_space),
                  _createElementVNode("div", _hoisted_1, "2011-" + _toDisplayString(new Date().getFullYear()) + " © MedSafe LLC", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_dialog, {
        modelValue: _unref(modal),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modal) ? (modal).value = $event : null)),
        maximized: _unref(maximized),
        "full-height": _unref(maximized),
        "full-width": _unref(maximized),
        class: _normalizeClass({
        'prepare-report': _unref(reportMode),
      })
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Suspense, null, {
            default: _withCtx(() => [
              _createVNode(ModalContainer, { onClose: closeModal })
            ]),
            _: 1
          }))
        ]),
        _: 1
      }, 8, ["modelValue", "maximized", "full-height", "full-width", "class"]),
      _createVNode(_component_q_dialog, {
        modelValue: messageShown.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((messageShown).value = $event)),
        seamless: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "row message-card bg-amber-6 text-black" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                default: _withCtx(() => [
                  _createElementVNode("pre", _hoisted_2, _toDisplayString(_unref(messageContent)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})